export const calculateAge = (birthday) => {
  if (!birthday) return;

  if (typeof birthday === 'string') birthday = new Date(birthday);

  birthday.setHours(0, 0, 0, 0);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  let age = today.getFullYear() - birthday.getFullYear();

  const monthsUntilBirthday = birthday.getMonth() - today.getMonth();
  const daysUntilBirthday = birthday.getDate() - today.getDate();
  if (monthsUntilBirthday > 0 || (monthsUntilBirthday === 0 && daysUntilBirthday > 0)) {
    age--;
  }

  return age;
};
